import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Aronui';
    src: url('/fonts/Aronui-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  body {
    /* font-family: 'Aronui', sans-serif; */
  }


  /* Start of FirebaseUI Custom Styles */

  #firebaseui-auth-container{
    width: 60%;
  }

  .firebaseui-title {
    font-size: 1rem;

  }

  .firebaseui-id-submit {
    background-color: #3a2f2f;
  color: #fff;
  border: none;
  // Adjust padding to potentially change the size of the button, smaller numbers mean smaller buttons
  padding: 10px 20px; // reduced from 12px 24px
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block; // ensures the clickable area doesn't extend full width
  width: auto; // only take up as much width as needed
  &:hover {
    background-color: #4c3e3e;
  }
  }

  /* Add other overrides for other FirebaseUI elements here, e.g., text fields, card containers, etc. */
  /* You need to inspect the elements or refer to the FirebaseUI CSS file to know the exact classes or elements to target. */
  .firebaseui-input {
    display: block;
    width: 100%; // Full width for mobile
    padding: 10px;
    margin: 10px 0;
    font-size: 1rem;
    border-radius: 5px;
    border: 2px solid #3a2f2f;  
  }

  .firebaseui-card {
    display: flex;
    border: solid;
  }

  
`;
